export default __webpack_public_path__ + "static/media/Pilgrim's Straps of the Aureate.b113ae92.jpg";